// @flow
import React from 'react';
import { get } from 'lodash';
import { Button } from '@elements';
import { withTranslation } from 'react-i18next';
import { createNsTranslator } from '@helpers/helpers';
import './ReportPagination.scss';

type Props = {
  meta: ?Object,
  isLoading: boolean,
  onPageChange: Function,
  itemsName: string,
  t: Function,
};

// Older API builds answer without a `meta` block; those responses are a single
// page by definition, so the control stays hidden rather than guessing.
const ReportPagination = ({
  meta, isLoading, onPageChange, itemsName, t,
}: Props) => {
  const _ = createNsTranslator('reports', t);

  const page = parseInt(get(meta, 'page', 1), 10);
  const perPage = parseInt(get(meta, 'perPage', 0), 10);
  const totalPages = parseInt(get(meta, 'totalPages', 1), 10);
  const totalCount = parseInt(get(meta, 'totalCount', 0), 10);

  if (!meta || (totalPages <= 1 && page <= 1)) return null;

  const from = ((page - 1) * perPage) + 1;
  const to = Math.min(page * perPage, totalCount);

  const showing = String(_('pagination/showing'))
    .replace('{from}', String(from))
    .replace('{to}', String(to))
    .replace('{total}', String(totalCount))
    .replace('{items}', itemsName);

  const pageOf = String(_('pagination/page_of'))
    .replace('{page}', String(page))
    .replace('{totalPages}', String(totalPages));

  return (
    <div className="reportPagination">
      <span className="showingRange">{showing}</span>
      <div className="paginationControls">
        <Button disabled={isLoading || page <= 1} onClick={() => onPageChange(page - 1)}>
          {_('pagination/previous')}
        </Button>
        <span className="pageIndicator">{pageOf}</span>
        <Button disabled={isLoading || page >= totalPages} onClick={() => onPageChange(page + 1)}>
          {_('pagination/next')}
        </Button>
      </div>
    </div>
  );
};

export default withTranslation()(ReportPagination);
